import { Slider } from './slider';
/**
 * SliderX component.
 */
export const SliderX = (options) => {
    return Slider(Object.assign(Object.assign({}, options), { orientation: 'horizontal' }));
};
SliderX.props = Object.assign(Object.assign({}, Slider.props), { defaultPosition: 'bottom' });
//# sourceMappingURL=sliderX.js.map